var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-wrapper"}},[_vm._t("header",function(){return [_c('Header')]}),_vm._t("sidebar",function(){return [_c('Sidebar')]}),_c('div',{staticClass:"page-wrapper"},[_c('router-view'),_vm._t("loader")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }